import React from 'react';
import styled, { css } from 'styled-components';
import { black100, cinnabar300 } from '../../../theme/colors';
import themeSizes from '../../../theme/themeSizes';
import { baseCaption } from '../../../theme/typography';
import ReactTooltip from "react-tooltip";
import CloseIcon from '@material-ui/icons/Close';

const RowStyle = styled.div`
    min-height: 38px;
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '14px 0'};
    border-bottom: 1px dashed #e2e8f0;
    
    &:last-child {
        border-bottom: none;
    }

    display: flex;
    flex-wrap: wrap;
    align-items: ${props => props.labelAlign || 'center'};
    ${baseCaption}
    
    ${props => props.noFlexWrap && css`
        flex-wrap: nowrap;
        align-items: ${props => props.labelAlign || 'center'};
        
        @media (max-width: 1024px) {
            flex-wrap: wrap !important;
        }
    `}
    
    & > span.form-row-label {
        width: 130px;
        flex-shrink: 0;
        padding-top: ${props => (props.labelAlign && props.labelAlign !== 'center') ? (props.labelAlign === 'flex-start' ? '6px' : props.labelAlign) : '0'};
        font-weight: 500;
        color: #334155;
        box-sizing: border-box;
        
        @media (max-width: 500px) {
            font-size: 13px;
        }
        
        ${props => props.isAsterisk && css`
            &:after {
                content: ' *';
                color: ${cinnabar300};
                font-weight: bold;
            }
        `};
        
        ${props => props.labelColor && css`
            color: ${props.labelColor};
        `};
        
        @media (max-width: 995px) {
            width: 100% !important;
            margin-bottom: 6px;
            padding-top: 0;
            &:empty {
                display: none !important;
            }
        }
    }
    
    & > :last-child,
    .form-row-input-wrapper {
        flex: 1;
        min-width: 0;
        max-width: 100%;
        box-sizing: border-box;
        > div {
            max-width: 100%;
            width: 100%;
            box-sizing: border-box;
        }
        @media (max-width: 995px) {
            width: 100% !important;
            max-width: 100% !important;
            > div {
                width: 100% !important;
                max-width: 100% !important;
            }
        }
    }

    @media (max-width: 995px) {
        flex-direction: column;
        align-items: stretch;
        justify-content: flex-start !important;
        margin: 0;
        padding: 12px 0;
    }
`;

export const FormRow = ({
    name = '',
    asterisk,
    rightElement = '',
    leftSideWidth,
    margin,
    labelColor,
    noFlexWrap = false,
    labelAlign,
    customStyles, isMandatory,
    labelMargin,
    toolIcon,
    isToolTip,
    tooltipData,
    tooltipId,
    ...restProps
}) => {
    const uniqueTooltipId = tooltipId || `tooltip-${(name || '').replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`;

    return (
        <RowStyle
            margin={margin}
            isAsterisk={asterisk}
            labelColor={labelColor}
            noFlexWrap={noFlexWrap}
            labelAlign={labelAlign}
            style={{ ...customStyles }}
            className="form-row-container"
            {...restProps}
        >
            <span className="form-row-label" style={{ width: leftSideWidth || '130px', marginLeft: labelMargin?.marginLeft || "0px" }}>
                {name} {isMandatory && <span style={{ color: '#E23A3A' }}>*</span>} {isToolTip &&
                    <>
                        <span data-tip data-for={uniqueTooltipId} style={{ cursor: 'pointer', display: 'inline-flex', verticalAlign: 'middle', marginLeft: '4px' }}>
                            {toolIcon}
                        </span>
                        <ReactTooltip
                            id={uniqueTooltipId}
                            place="top"
                            effect="solid"
                            type="dark"
                        >
                            <span style={{ maxWidth: "260px", display: "inline-block", fontSize: "12px", lineHeight: "1.4", wordBreak: "break-word" }}>
                                {tooltipData}
                            </span>
                        </ReactTooltip>
                    </>
                }</span>



            <div className="form-row-input-wrapper">
                {rightElement}
            </div>
        </RowStyle>
    )
}